var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      id: "elements"
    }
  }, [_c("b-jumbotron", [_c("b-row", [_c("b-col", [_c("b-alert", {
    staticClass: "pb-4",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      show: "",
      variant: "success"
    }
  }, [_vm._v("\n          Reductions\n          "), _c("b-button", {
    staticStyle: {
      float: "right"
    },
    attrs: {
      variant: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.prompt_Add();
      }
    }
  }, [_vm._v("Ajouter")])], 1)], 1)], 1), _vm._v(" "), _c("b-row", [_c("table", {
    staticClass: "col-12"
  }, [_c("thead", [_c("th"), _vm._v(" "), _c("th", [_vm._v("1ere reduction")]), _vm._v(" "), _c("th", [_vm._v("2eme reduction")]), _vm._v(" "), _c("th", [_vm._v("3eme reduction")])]), _vm._v(" "), _vm.isReady ? _c("tbody", [_c("tr", [_c("td", [_vm._v("Hammam")]), _vm._v(" "), _c("td", [_c("input", {
    staticClass: "form-control",
    attrs: {
      type: "number",
      max: "100",
      min: "0"
    },
    domProps: {
      value: _vm.reductions[0].red1
    },
    on: {
      change: function ($event) {
        return _vm.updateValue($event, 0, 1);
      }
    }
  })]), _vm._v(" "), _c("td", [_c("input", {
    staticClass: "form-control",
    attrs: {
      type: "number",
      max: "100",
      min: "0"
    },
    domProps: {
      value: _vm.reductions[0].red2
    },
    on: {
      change: function ($event) {
        return _vm.updateValue($event, 0, 2);
      }
    }
  })]), _vm._v(" "), _c("td", [_c("input", {
    staticClass: "form-control",
    attrs: {
      type: "number",
      max: "100",
      min: "0"
    },
    domProps: {
      value: _vm.reductions[0].red3
    },
    on: {
      change: function ($event) {
        return _vm.updateValue($event, 0, 3);
      }
    }
  })])]), _vm._v(" "), _c("tr", [_c("td", [_vm._v("Piscine non-couverte")]), _vm._v(" "), _c("td", [_c("input", {
    staticClass: "form-control",
    attrs: {
      type: "number",
      max: "100",
      min: "0"
    },
    domProps: {
      value: _vm.reductions[1].red1
    },
    on: {
      change: function ($event) {
        return _vm.updateValue($event, 1, 1);
      }
    }
  })]), _vm._v(" "), _c("td", [_c("input", {
    staticClass: "form-control",
    attrs: {
      type: "number",
      max: "100",
      min: "0"
    },
    domProps: {
      value: _vm.reductions[1].red2
    },
    on: {
      change: function ($event) {
        return _vm.updateValue($event, 1, 2);
      }
    }
  })]), _vm._v(" "), _c("td", [_c("input", {
    staticClass: "form-control",
    attrs: {
      type: "number",
      max: "100",
      min: "0"
    },
    domProps: {
      value: _vm.reductions[1].red3
    },
    on: {
      change: function ($event) {
        return _vm.updateValue($event, 1, 3);
      }
    }
  })])]), _vm._v(" "), _c("tr", [_c("td", [_vm._v("Piscine couverte")]), _vm._v(" "), _c("td", [_c("input", {
    staticClass: "form-control",
    attrs: {
      type: "number",
      max: "100",
      min: "0"
    },
    domProps: {
      value: _vm.reductions[2].red1
    },
    on: {
      change: function ($event) {
        return _vm.updateValue($event, 2, 1);
      }
    }
  })]), _vm._v(" "), _c("td", [_c("input", {
    staticClass: "form-control",
    attrs: {
      type: "number",
      max: "100",
      min: "0"
    },
    domProps: {
      value: _vm.reductions[2].red2
    },
    on: {
      change: function ($event) {
        return _vm.updateValue($event, 2, 2);
      }
    }
  })]), _vm._v(" "), _c("td", [_c("input", {
    staticClass: "form-control",
    attrs: {
      type: "number",
      max: "100",
      min: "0"
    },
    domProps: {
      value: _vm.reductions[2].red3
    },
    on: {
      change: function ($event) {
        return _vm.updateValue($event, 2, 3);
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c("button", {
    staticClass: "btn btn-success btn-block mt-4",
    on: {
      click: _vm.updateReds
    }
  }, [_vm._v("Sauvegarder ")])])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };